import { ThankYou } from "./ThankYou";

export const isEmpty = (thankYou: ThankYou) =>
    !thankYou?.text || !thankYou.recipient.name || !thankYou.recipient.username;
